import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Header = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setShowDropdown(false);
  }, [location]);

  const handleNavClick = (e, targetId) => {
    if (location.pathname !== '/') {
      e.preventDefault();
      navigate('/' + targetId);
    }
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-950/95 backdrop-blur-md border-b border-slate-800 py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
            <SafeIcon name="PhoneCall" className="text-white text-xl" />
          </div>
          <span className="text-2xl font-bold text-white tracking-tight">
            Auto<span className="text-blue-500">Reception</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-300">
          <div className="relative" onMouseLeave={() => setShowDropdown(false)}>
            <button
              className="flex items-center gap-1 hover:text-white transition-colors py-2"
              onMouseEnter={() => setShowDropdown(true)}
              onClick={() => setShowDropdown(!showDropdown)}
            >
              Industries
              <SafeIcon name="ChevronDown" className={`text-xs transition-transform duration-300 ${showDropdown ? 'rotate-180' : ''}`} />
            </button>

            <div className={`absolute top-full -left-4 pt-4 transition-all duration-300 ${showDropdown ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-2 invisible pointer-events-none'}`}>
              <div className="bg-slate-900 border border-slate-800 rounded-2xl p-2 w-64 shadow-2xl">
                <Link to="/hvac" className="flex items-center gap-3 p-3 hover:bg-slate-800 rounded-xl transition-colors">
                  <div className="w-8 h-8 bg-orange-500/10 rounded-lg flex items-center justify-center">
                    <SafeIcon name="Tool" className="text-orange-400" />
                  </div>
                  <span>HVAC & Home Services</span>
                </Link>
                <Link to="/dentists" className="flex items-center gap-3 p-3 hover:bg-slate-800 rounded-xl transition-colors">
                  <div className="w-8 h-8 bg-blue-500/10 rounded-lg flex items-center justify-center">
                    <SafeIcon name="Heart" className="text-blue-400" />
                  </div>
                  <span>Dentists</span>
                </Link>
                <Link to="/legal" className="flex items-center gap-3 p-3 hover:bg-slate-800 rounded-xl transition-colors">
                  <div className="w-8 h-8 bg-emerald-500/10 rounded-lg flex items-center justify-center">
                    <SafeIcon name="Briefcase" className="text-emerald-400" />
                  </div>
                  <span>Legal & Law Firms</span>
                </Link>
                <Link to="/real-estate" className="flex items-center gap-3 p-3 hover:bg-slate-800 rounded-xl transition-colors">
                  <div className="w-8 h-8 bg-purple-500/10 rounded-lg flex items-center justify-center">
                    <SafeIcon name="Home" className="text-purple-400" />
                  </div>
                  <span>Real Estate</span>
                </Link>
                <Link to="/med-spa" className="flex items-center gap-3 p-3 hover:bg-slate-800 rounded-xl transition-colors">
                  <div className="w-8 h-8 bg-pink-500/10 rounded-lg flex items-center justify-center">
                    <SafeIcon name="Scissors" className="text-pink-400" />
                  </div>
                  <span>Med Spas & Salons</span>
                </Link>
              </div>
            </div>
          </div>

          <Link to="/about" className="hover:text-white transition-colors">About Us</Link>
          <Link to="/integrations" className="hover:text-white transition-colors">Integrations</Link>
          <a href="#calculator" onClick={(e) => handleNavClick(e, '#calculator')} className="hover:text-white transition-colors">ROI Calculator</a>
          <a href="#pricing" onClick={(e) => handleNavClick(e, '#pricing')} className="hover:text-white transition-colors">Pricing</a>
          <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="hover:text-white transition-colors">FAQ</a>
        </nav>

        <div className="flex items-center gap-4">
          <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="hidden sm:block bg-blue-600 hover:bg-blue-500 text-white px-6 py-2.5 rounded-full font-semibold transition-all shadow-[0_0_15px_rgba(37,99,235,0.4)]">
            Start Free Trial
          </a>
          <button className="md:hidden text-white" aria-label="Open navigation menu">
            <SafeIcon name="Menu" className="text-2xl" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;